import { SrIcon } from "@/components/ui/SrIcon";
import { describeSendFailure } from "@/lib/invoice-send";

interface InvoiceSendFailedAlertProps {
  code?: string | null;
  detail?: string | null;
}

/**
 * Vises i opprett-faktura-dialogen når PowerOffice tok imot fakturaen, men
 * nektet å sende den. Dialogen holdes åpen, så dette er det brukeren ser,
 * ikke en toast som forsvinner.
 */
export function InvoiceSendFailedAlert({ code, detail }: InvoiceSendFailedAlertProps) {
  const text = describeSendFailure({ code, detail });
  return (
    <div
      role="alert"
      className="rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm space-y-1"
    >
      <p className="font-semibold text-destructive flex items-center gap-1.5">
        <SrIcon name="alert-triangle" className="w-4 h-4 shrink-0" />
        {text.title}
      </p>
      <p>{text.explanation}</p>
      <p className="font-medium">{text.action}</p>
    </div>
  );
}
